import * as React from 'react';

const SvgAdditional = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M47.832 39.083h-5.25v-5.25c0-.956-.793-1.75-1.75-1.75s-1.75.794-1.75 1.75v5.25h-5.25c-.957 0-1.75.794-1.75 1.75 0 .957.793 1.75 1.75 1.75h5.25v5.25c0 .957.793 1.75 1.75 1.75s1.75-.793 1.75-1.75v-5.25h5.25c.957 0 1.75-.793 1.75-1.75 0-.956-.793-1.75-1.75-1.75ZM51.333 19.88V9.287c0-3.29-1.493-4.62-5.203-4.62h-9.427c-3.71 0-5.203 1.33-5.203 4.62v10.57c0 3.313 1.493 4.62 5.203 4.62h9.427c3.71.023 5.203-1.307 5.203-4.597ZM24.501 19.88V9.287c0-3.29-1.493-4.62-5.203-4.62H9.871c-3.71 0-5.203 1.33-5.203 4.62v10.57c0 3.313 1.493 4.62 5.203 4.62h9.427c3.71.023 5.203-1.307 5.203-4.597ZM24.501 46.13v-9.427c0-3.71-1.493-5.203-5.203-5.203H9.871c-3.71 0-5.203 1.493-5.203 5.203v9.427c0 3.71 1.493 5.203 5.203 5.203h9.427c3.71 0 5.203-1.493 5.203-5.203Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgAdditional;
